<template>
  <div class="isolation-aging-parameters">
    <s-empty-list
      v-if="!parameters && !loading"
      class="isolation-aging-parameters__empty-list"
    />
    <b-row
      v-else-if="loading"
      align-h="center"
      align-v="center"
      class="isolation-aging-parameters__loader"
    >
      <s-loader class="py-5" size="lg" />
    </b-row>
    <view-edit-panel
      v-else-if="parameters"
      class="isolation-aging-parameters-data px-0"
      permission-to-edit="PER013"
      saving-success-code="MS032"
      hide-edit-when-without-permission
      :value="parameters"
      :disable-save="isFormInvalid"
      :loading="loading"
      @changing="save"
    >
      <div
        slot-scope="data"
        class="col-12"
      >
        <parameters-form
          :parameters="data.item"
          :humidity-source="humiditySource"
          :edit-mode="data.editing"
          :is-loading="loading"
          :is-saving="saving"
          :key="formKey"
          :installation-time-zone="tabInfo.installationTimeZone"
          @force-rerender-form="forceRerenderForm"
          @invalid-form="invalidFormHandler"
        />
      </div>
    </view-edit-panel>
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service
 from '@/domain/services/installation/engineering/isolationAging/isolationAgingService';
import ViewEditPanel from '@/components/ViewEditPanel';
import ParametersForm
  from '@/domain/components/installation/engineering/isolationAging/ParametersForm';
import {
  formatter as dateTimeFormatter,
  setToStartOfDay,
} from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

export default {
  name: 'IsolationAgingParametersTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ViewEditPanel,
    ParametersForm,
  },
  data: () => ({
    parameters: {},
    humiditySource: [],
    loading: false,
    saving: false,
    isFormInvalid: false,
    formKey: 0,
  }),
  computed: {
    assetModuleId() {
      const { assetModuleId } = this.$route.params;
      return assetModuleId;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
      this.refreshData(true);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;

      this.loading = showLoading;

      const promises = [
        Service.getParameters(this.assetModuleId),
        Service.getHumiditySource(this.assetModuleId),
      ];

      Promise.allSettled(promises)
        .then((responses) => {
          [this.parameters, this.humiditySource] = (responses || []).map(item => item.value);
          this.splitDateTimeValues();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save({ newValue, accept, reject }) {
      this.saving = true;

      const payload = {
        ...newValue,
      };

      return Service.editParameters(this.assetModuleId, payload)
        .then(() => {
          accept();
          this.refreshData(true);
          this.forceRerenderForm();
        })
        .catch(reject)
        .finally(() => {
          this.saving = false;
        });
    },
    splitDateTimeValues() {
      const {
        initialDateTime,
        finalDateTime,
      } = this.parameters;

      this.parameters = {
        ...this.parameters,
        initialDate: setToStartOfDay(initialDateTime),
        initialTime: dateTimeFormatter(initialDateTime, formats.ISO_TIME),
        finalDate: setToStartOfDay(finalDateTime),
        finalTime: dateTimeFormatter(finalDateTime, formats.ISO_TIME),
      };
    },
    invalidFormHandler(value) {
      this.isFormInvalid = value;
    },
    forceRerenderForm() {
      this.formKey += 1;
    },
  },
};
</script>

<style lang="sass" scoped>
.isolation-aging-parameters
  &__empty-list
    display: flex
    flex-direction: column
    justify-content: center
    height: 415px
</style>
